<template>
  <div>
    <v-progress-linear indeterminate color="purple" class="mb-2" v-if="cargando" />
    <ag-grid-vue
      :gridOptions="gridOptions"
      class="ag-theme-balham ag-grid-table-reporte-ejecucion-presupuestaria"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="items"
      rowSelection="single"
      colResizeDefault="shift"
      :animateRows="false"
      :floatingFilter="true"
      :pagination="false"
      :pinnedBottomRowData="pinnedBottomRowData"
      :alwaysShowVerticalScroll="true"
      :suppressPaginationPanel="true"
      @first-data-rendered="onFirstDataRendered"
      @grid-ready="onGridReady">
    </ag-grid-vue>
  </div>
</template>
  
<script>
import { AgGridVue } from 'ag-grid-vue';
import { cellRendererNumeroRegistro, formatearValorAMoneda } from '../utils';

export default {
  name: 'ListadoReporteEjecucionPresupuestaria',
  components: {
    AgGridVue,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    cargando: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    pinnedBottomRowData() {
      return [this.obtenerTotales()];
    },
  },
  data() {
    return {
      gridOptions: {
        suppressPropertyNamesCheck: true,
        suppressMovableColumns: true,
        localeText: {
          noRowsToShow: 'No hay filas para mostrar',
          contains: 'Contiene',
          notContains: 'No Contiene',
          equals: 'Es Igual',
          notEqual: 'No es Igual',
          startsWith: 'Comienza con',
          endsWith: 'Termina con',
          filterOoo: 'Filtrar...',
        },
        enableCellTextSelection: true,
      },
      defaultColDef: {
        sortable: false,
        filter: true,
        floatingFilter: true,
        //editable: false,
        resizable: true,
        suppressMenu: true,
      },
      columnDefs: [
        {
          headerName: 'NRO. REG.',
          cellRenderer: cellRendererNumeroRegistro,
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: false,
          minWidth: 150,
          maxWidth: 150,
        },
        {
          headerName: 'CÓDIGO',
          field: 'codigo',
          filter: true,
          minWidth: 150,
        },
        {
          headerName: 'DETALLE',
          field: 'detalle',
          filter: true,
          minWidth: 350,
        },
        {
          headerName: 'ACEPTA REGISTRO',
          field: 'acepta_registro',
          cellRenderer: (params) => {
            if (params.node.rowPinned) {
              return undefined;
            }

            const aceptaRegistro = params.data.acepta_registro;
            const texto = aceptaRegistro ? 'SI' : 'NO';
            const colorTexto = aceptaRegistro ? 'green' : 'red';

            return /*html*/ `<span style="color: ${colorTexto}">${texto}</span>`;
          },
          valueGetter: (params) => {
            const aceptaRegistro = params.data.acepta_registro ? 'SI' : 'NO';

            return aceptaRegistro;
          },
          filter: true,
          minWidth: 130,
          maxWidth: 130,
        },
        {
          headerName: 'PRESUPUESTO INICIAL',
          field: 'presupuesto_inicial',
          filter: false,
          minWidth: 200,
          maxWidth: 200,
          type: 'numericColumn',
          valueFormatter: (params) => {
            return formatearValorAMoneda(params.value);
          },
        },
        {
          headerName: 'DESEMBOLSADO',
          marryChildren: true,
          children: [
            {
              headerName: 'ENERO',
              field: 'enero',
              filter: false,
              minWidth: 120,
              maxWidth: 120,
              type: 'numericColumn',
              valueFormatter: (params) => {
                return formatearValorAMoneda(params.value);
              },
            },
            {
              headerName: 'FEBRERO',
              field: 'febrero',
              filter: false,
              minWidth: 120,
              maxWidth: 120,
              type: 'numericColumn',
              valueFormatter: (params) => {
                return formatearValorAMoneda(params.value);
              },
            },
            {
              headerName: 'MARZO',
              field: 'marzo',
              filter: false,
              minWidth: 120,
              maxWidth: 120,
              type: 'numericColumn',
              valueFormatter: (params) => {
                return formatearValorAMoneda(params.value);
              },
            },
            {
              headerName: 'ABRIL',
              field: 'abril',
              filter: false,
              minWidth: 120,
              maxWidth: 120,
              type: 'numericColumn',
              valueFormatter: (params) => {
                return formatearValorAMoneda(params.value);
              },
            },
            {
              headerName: 'MAYO',
              field: 'mayo',
              filter: false,
              minWidth: 120,
              maxWidth: 120,
              type: 'numericColumn',
              valueFormatter: (params) => {
                return formatearValorAMoneda(params.value);
              },
            },
            {
              headerName: 'JUNIO',
              field: 'junio',
              filter: false,
              minWidth: 120,
              maxWidth: 120,
              type: 'numericColumn',
              valueFormatter: (params) => {
                return formatearValorAMoneda(params.value);
              },
            },
            {
              headerName: 'JULIO',
              field: 'julio',
              filter: false,
              minWidth: 120,
              maxWidth: 120,
              type: 'numericColumn',
              valueFormatter: (params) => {
                return formatearValorAMoneda(params.value);
              },
            },
            {
              headerName: 'AGOSTO',
              field: 'agosto',
              filter: false,
              minWidth: 120,
              maxWidth: 120,
              type: 'numericColumn',
              valueFormatter: (params) => {
                return formatearValorAMoneda(params.value);
              },
            },
            {
              headerName: 'SEPTIEMBRE',
              field: 'septiembre',
              filter: false,
              minWidth: 120,
              maxWidth: 120,
              type: 'numericColumn',
              valueFormatter: (params) => {
                return formatearValorAMoneda(params.value);
              },
            },
            {
              headerName: 'OCTUBRE',
              field: 'octubre',
              filter: false,
              minWidth: 120,
              maxWidth: 120,
              type: 'numericColumn',
              valueFormatter: (params) => {
                return formatearValorAMoneda(params.value);
              },
            },
            {
              headerName: 'NOVIEMBRE',
              field: 'noviembre',
              filter: false,
              minWidth: 120,
              maxWidth: 120,
              type: 'numericColumn',
              valueFormatter: (params) => {
                return formatearValorAMoneda(params.value);
              },
            },
            {
              headerName: 'DICIEMBRE',
              field: 'diciembre',
              filter: false,
              minWidth: 120,
              maxWidth: 120,
              type: 'numericColumn',
              valueFormatter: (params) => {
                return formatearValorAMoneda(params.value);
              },
            },
          ],
        },
        {
          headerName: 'TOTAL',
          field: 'total',
          filter: false,
          minWidth: 120,
          maxWidth: 120,
          type: 'numericColumn',
          valueFormatter: function (params) {
            return formatearValorAMoneda(params.value);
          },
        },
        {
          headerName: 'SALDO PRESUPUESTARIO',
          field: 'saldo_presupuestario',
          filter: false,
          minWidth: 200,
          maxWidth: 200,
          type: 'numericColumn',
          valueFormatter: function (params) {
            return formatearValorAMoneda(params.value);
          },
        },
      ],
    };
  },
  methods: {
    onGridReady(params) {
      params.api.sizeColumnsToFit();
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    obtenerTotales() {
      const totales = {
        presupuesto_inicial: 0,
        enero: 0,
        febrero: 0,
        marzo: 0,
        abril: 0,
        mayo: 0,
        junio: 0,
        julio: 0,
        agosto: 0,
        septiembre: 0,
        octubre: 0,
        noviembre: 0,
        diciembre: 0,
        total: 0,
        saldo_presupuestario: 0,
      };

      this.items.forEach((item) => {
        totales.presupuesto_inicial += Number(item.presupuesto_inicial);
        totales.enero += Number(item.enero);
        totales.febrero += Number(item.febrero);
        totales.marzo += Number(item.marzo);
        totales.abril += Number(item.abril);
        totales.mayo += Number(item.mayo);
        totales.junio += Number(item.junio);
        totales.julio += Number(item.julio);
        totales.agosto += Number(item.agosto);
        totales.septiembre += Number(item.septiembre);
        totales.octubre += Number(item.octubre);
        totales.noviembre += Number(item.noviembre);
        totales.diciembre += Number(item.diciembre);
        totales.total += Number(item.total);
        totales.saldo_presupuestario += Number(item.saldo_presupuestario);
      });

      return totales;
    },
  },
  created() {},
};
</script>

<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';
@import './../css/styles.css';

.ag-grid-table-reporte-ejecucion-presupuestaria {
  height: calc(var(--vh, 1vh) * 100 - 19.5rem);
}

.ag-header-group-cell-label {
  justify-content: center !important;
}
</style>